import React, { useState } from 'react';
import { useAppSelector } from 'hooks';

import { tponeUrl } from '~constants/tpone';

import { Button } from '~components';
import { InputProps } from '~components/form-fields';
import Modal from '~components/Modal';

import { selectCrossOriginToken } from '~main/selectors/login';

const FormInputImage: React.FC<InputProps> = ({ value }) => {
  const token = useAppSelector(selectCrossOriginToken);
  const { id, photos } = value;
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  let baseUrl = `${tponeUrl}/download-file.asp?apptID=${id}&doc_TYPE=apptImage`;
  if (token) baseUrl += `&tav_session=${encodeURIComponent(token)}`;

  const handleImageClick = (imagePath: string) => {
    setPreviewImage(imagePath);
    setShowPreview(true);
  };

  if (!photos) return <></>;

  return (
    <div className="form-image">
      {photos.map((imagePath: string, index: number) => {
        const url = `${baseUrl}&fn=${encodeURIComponent(imagePath)}`;
        return (
          <div key={index} className="image-box">
            <img
              src={url}
              alt={`Image ${imagePath}`}
              className="img-fluid object-contain"
              onClick={() => handleImageClick(url)}
            />
          </div>
        );
      })}
      <Modal
        setIsOpen={setShowPreview}
        isOpen={showPreview}
        bodyClassName="m-0 p-0"
        className="features"
        header="Image preview"
        headerClassName="header"
        includeFooter={false}
        size="xl"
        onClosed={() => {
          setPreviewImage(null);
        }}
      >
        <div className="modal-body form-image">
          <div className="image-box modal-image">
            <img src={previewImage ?? ''} alt={`Appointment Image Preview`} className="img-fluid object-contain" />
          </div>
          <Button
            href={`${previewImage ?? ''}`}
            download={`${previewImage ?? ''}`}
            aria-label={`Download ${previewImage}`}
          >
            Download Image
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default FormInputImage;
